export default __webpack_public_path__ + "static/media/ClientesIconGray.ec44156e.svg";